export default __webpack_public_path__ + "static/media/card10.ba5fe4c2.svg";